import { Button } from '@design-system/Button';
import CircularLoader from '../CircularLoader';
import { cn } from '@/utils/styles';

export interface ActionButtonsProps {
  primaryActionLabel: string;
  primaryActionIsSubmit?: boolean;
  primaryActionOnClick?: () => void;
  secondaryActionLabel?: string;
  secondaryActionOnClick?: () => void;
  primaryActionLoading?: boolean;
  primartActionDisabled?: boolean;
  isConsentScreen?: boolean;
}

export const ActionButtons = ({
  primaryActionLabel,
  primaryActionIsSubmit,
  primaryActionOnClick,
  secondaryActionLabel,
  secondaryActionOnClick,
  primaryActionLoading,
  primartActionDisabled,
  isConsentScreen
}: ActionButtonsProps) => {
  return (
    <>
      <Button
        type={primaryActionIsSubmit ? 'submit' : 'button'}
        className={cn("w-full py-3 text-white font-semibold bg-black rounded-lg mt-4 disabled:opacity-50", isConsentScreen && "md:max-w-sm")}
        onClick={primaryActionIsSubmit ? undefined : primaryActionOnClick}
        disabled={primartActionDisabled || primaryActionLoading}
      >
        {primaryActionLoading ? <CircularLoader /> : primaryActionLabel}
      </Button>
      {secondaryActionLabel && secondaryActionOnClick && (
        <Button
          variant="secondary"
          className={cn([
            'w-full py-3 font-semibold rounded-lg',
            isConsentScreen && "md:max-w-sm"
          ])}
          onClick={secondaryActionOnClick}
        >
          {secondaryActionLabel}
        </Button>
      )}
    </>
  );
};
